export const WorldConstants = {
  POPULATE_WORLD: 'LOAD_WORLD_FROM_CHRONICLE',

  GET_SUBGROUPS_REQUEST: 'GET_WORLD_SUBGROUPS_REQUEST',
  GET_SUBGROUPS_SUCCESS: 'GET_WORLD_SUBGROUPS_SUCCESS',
  GET_SUBGROUPS_FAILURE: 'GET_WORLD_SUBGROUPS_FAILURE',
};
